import { msg } from "@lingui/core/macro";
import { useNavigate } from "@tanstack/solid-router";
import { useI18n } from "@/providers/i18n-provider";
import { NotFoundState } from "@/components/ui/not-found-state";

/**
 * Router's global `defaultNotFoundComponent`: any unknown URL shows
 * this state instead of a blank screen. It is rendered inside the root's
 * `<Outlet>` (with all providers available).
 */
export function NotFoundRoute() {
  const { t } = useI18n();
  const navigate = useNavigate();
  return (
    // `data-testid` because bundle startup gate needs to distinguish "route
    // rendered" from "router does not recognize it": without this an unknown URL
    // renders this screen, has visible text, and test accepts it as valid.
    <div class="flex min-h-0 flex-1 items-center justify-center" data-testid="not-found-route">
      <NotFoundState
        variant="not-found"
        title={t(msg`Page not found`)}
        description={t(msg`The page you're looking for doesn't exist or has moved.`)}
        primaryAction={{
          label: t(msg`Go home`),
          onClick: () => {
            void navigate({ to: "/" });
          },
        }}
      />
    </div>
  );
}
